import { css } from "@linaria/core"

import { ButtonStyles } from "@/components/Button/ButtonStyles.ts"
import { dropdownShadow, focusOutline } from "@/styles/mixins.ts"
import * as textStyles from "@/styles/textStyles.ts"

export const DropdownMenuStyles = {
  Trigger: css`
    &:not(.${ButtonStyles.Base}) {
      cursor: pointer;
      padding: 0;

      color: var(--secondary-text-color);
      transition: color 0.2s ease-in-out;

      &:focus-visible {
        ${focusOutline};
      }

      &[tabindex="-1"]:focus-visible {
        outline: none;
      }

      &:hover {
        color: var(--text-color);
      }

      &[data-state="open"] {
        color: var(--text-color);
      }
    }
  `,

  Content: css`
    display: flex;
    flex-direction: column;
    gap: 4px;

    padding: 16px 12px;

    border: 1px solid var(--separator-color);
    border-radius: var(--border-radius-20);

    background-color: var(--island-background-color);

    ${dropdownShadow};

    @keyframes fade-in {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }

    @keyframes fade-out {
      from {
        opacity: 1;
      }

      to {
        opacity: 0;
      }
    }

    &[data-state="open"] {
      animation: fade-in 0.1s ease-out;
    }

    &[data-state="closed"] {
      animation: fade-out 0.1s ease-in;
    }
  `,

  Item: css`
    cursor: default;

    padding: 4px 8px;

    &:focus-visible {
      outline: none;
      border-radius: var(--border-radius-8);
      background-color: var(--text-color-5);
    }

    &:hover:not([data-disabled]) {
      cursor: pointer;
      border-radius: var(--border-radius-8);
      background-color: var(--text-color-5);
    }
  `,

  SelectedItem: css`
    border-radius: var(--border-radius-8);
    background-color: var(--text-color-5);
  `,

  Label: css`
    ${textStyles.smallFontSize};

    color: var(--secondary-text-color);
  `,

  Separator: css`
    height: 1px;
    background-color: var(--separator-color);
    margin: 0 -12px;
  `
}